module.exports = __webpack_public_path__ + "img/zh_CN.a8983d21.png";